export enum PlanningItemReportState {
    completed = 'completed',
    notHome = 'notHome',
    reschedule = 'reschedule',
    cancel = 'cancel',
    completedWithOffer = 'completedWithOffer',
    completedNoOffer = 'completedNoOffer',
}
